/**
 * SiphoxAdmin.tsx — Admin → Integrations → SiPhox Health.
 * Thin wrapper over the reusable LabIntegrationAdmin.
 */
import { LabIntegrationAdmin } from '@/pages/admin/LabIntegrationAdmin';

export function SiphoxAdmin() {
  return (
    <LabIntegrationAdmin
      integrationKey="siphox"
      title="SiPhox Health"
      subtitle="At-home blood-test kits via the SiPhox Health API"
      vendorName="SiPhox"
    />
  );
}
